.forwardButton {
  position: absolute;
  top: 94px;
  right: -66px;
  display: none;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid rgb(0 0 0 / 12%);
  border-radius: 100%;

  &:hover {
    background-color: rgb(0 0 0 / 5%);
  }
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    display: grid;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    display: grid;
  }
}
